module.exports = __webpack_public_path__ + "static/media/SmartsoftLogo.23be705e.svg";